// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalOptions_btnOptions__7NrTi button {
  margin-right: 0;
  border: 1px solid #d5dbe5;
  border-radius: 999px;
  font-size: 15px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f7f9fc;
  padding: 0;
}
.AdditionalOptions_btnOptions__7NrTi {
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.AdditionalOptions_btnOptions__7NrTi button > img,
.AdditionalOptions_btnOptions__7NrTi button img {
  /* Force small action icons inside the message toolbar to a consistent size */
  width: 14px !important;
  height: 14px !important;
  display: inline-block;
  object-fit: contain;
}

.AdditionalOptions_moreOptions__QDsXr {
  bottom: -6px;
  height: 10px;
  width: 10px;
  right: 35px;
}

.AdditionalOptions_moreOptions__QDsXr:focus {
  outline: none;
}

.AdditionalOptions_menuGrid__BZHIL {
  font-size: 12;
  margin-right: -20px;
  &:hover {
    backgroundcolor: "#f0f0f0";
  }
}

.AdditionalOptions_menuGridLine__p2TZW {
  font-size: 12;
  &:hover {
    backgroundcolor: "#f0f0f0";
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/UaeMt/AdditionalOptions/AdditionalOptions.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,6EAA6E;EAC7E,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".btnOptions button {\n  margin-right: 0;\n  border: 1px solid #d5dbe5;\n  border-radius: 999px;\n  font-size: 15px;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7f9fc;\n  padding: 0;\n}\n.btnOptions {\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.btnOptions button > img,\n.btnOptions button img {\n  /* Force small action icons inside the message toolbar to a consistent size */\n  width: 14px !important;\n  height: 14px !important;\n  display: inline-block;\n  object-fit: contain;\n}\n\n.moreOptions {\n  bottom: -6px;\n  height: 10px;\n  width: 10px;\n  right: 35px;\n}\n\n.moreOptions:focus {\n  outline: none;\n}\n\n.menuGrid {\n  font-size: 12;\n  margin-right: -20px;\n  &:hover {\n    backgroundcolor: \"#f0f0f0\";\n  }\n}\n\n.menuGridLine {\n  font-size: 12;\n  &:hover {\n    backgroundcolor: \"#f0f0f0\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnOptions": `AdditionalOptions_btnOptions__7NrTi`,
	"moreOptions": `AdditionalOptions_moreOptions__QDsXr`,
	"menuGrid": `AdditionalOptions_menuGrid__BZHIL`,
	"menuGridLine": `AdditionalOptions_menuGridLine__p2TZW`
};
export default ___CSS_LOADER_EXPORT___;
